import { api } from './base';

import { MutationArg, Pageable } from 'v2/types';
import { RewardHistory, RewardHistoryFilter, RewardIds, RewardModel } from 'v2/types/RewardModel';
import { SWRKeyPaginationWithExtra, SWRKeyValue } from 'v2/types/swr';
import { exportFile, normalizeSearch, shitFilterMapper } from 'v2/utils';

export const rewardsService = {
  createReward(_key: string, { arg }: MutationArg<Omit<RewardModel, 'id'>>): Promise<RewardModel> {
    return api.post('admin/user-reward', { json: arg }).json();
  },

  updateReward([_key, rewardId]: SWRKeyValue, { arg }: MutationArg<Omit<RewardModel, 'id'>>): Promise<RewardModel> {
    return api.put(`admin/user-reward/${rewardId}`, { json: arg }).json();
  },

  createRewards(_key: string, { arg }: MutationArg<Omit<RewardModel, 'id'>[]>): Promise<RewardIds> {
    return api.post('admin/user-reward/bulk', { json: arg }).json();
  },

  updateRewards(_key: string, { arg }: MutationArg<RewardModel[]>): Promise<RewardIds> {
    return api.put('admin/user-reward/bulk', { json: arg }).json();
  },

  getRewardsByIds([_key, ids]: [string, RewardIds]): Promise<RewardModel[]> {
    return api.get('admin/user-reward/ids', { searchParams: { rewardIds: ids.toString() } }).json();
  },

  getRewardById([_key, rewardId]: SWRKeyValue): Promise<RewardModel> {
    return api.get(`admin/user-reward/${rewardId}`).json();
  },

  deleteRewards([_key, ids]: [string, RewardIds]): Promise<void> {
    return api.delete('admin/user-reward/bulk', { searchParams: { rewardIds: ids.toString() } }).json();
  },

  deleteReward([_key, id]: SWRKeyValue): Promise<void> {
    return api.delete(`admin/user-reward/${id}`).json();
  },

  getRewardsHistory([_key, page, limit, filter]: SWRKeyPaginationWithExtra<RewardHistoryFilter>): Promise<
    Pageable<RewardHistory>
  > {
    return api
      .get('admin/user-win-reward', {
        searchParams: normalizeSearch({ page, limit, filter: shitFilterMapper(filter) }),
      })
      .json();
  },

  exportRewardsHistory(
    [_key, filter]: [string, RewardHistoryFilter],
    { arg }: MutationArg<{ startDate: string; endDate: string }>
  ): Promise<void> {
    return api
      .get('admin/user-win-reward/export', {
        searchParams: normalizeSearch({ ...arg, filter: shitFilterMapper(filter) }),
      })
      .blob()
      .then((blob) => exportFile(blob, 'rewards_history'));
  },
};
